import { render, staticRenderFns } from "./PersonInstall.vue?vue&type=template&id=4eb05438&scoped=true"
import script from "./PersonInstall.vue?vue&type=script&lang=js"
export * from "./PersonInstall.vue?vue&type=script&lang=js"
import style0 from "./PersonInstall.vue?vue&type=style&index=0&id=4eb05438&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb05438",
  null
  
)

export default component.exports